module.exports = __webpack_public_path__ + "assets/img/2002.396df28e.svg";